import axios from 'axios'
import Message from 'element-ui/lib/message'
import store from '../store'

let redirectingToLogin = false

function responseMessage(data) {
  if (typeof data === 'string') return data
  return data?.message || ''
}

function userFacingMessage(value) {
  const message = String(value || '')
  if (/PreparedStatementCallback|bad SQL grammar|BadSqlGrammarException|java\.sql\./i.test(message)) {
    return '服务端数据查询失败，请刷新重试；如持续出现请联系管理员查看服务日志。'
  }
  return message
}

function isLoginExpired(status, data) {
  if (status === 401) return true
  const message = responseMessage(data)
  return [
    '登录状态无效',
    '登录状态已失效',
    '登录已过期',
    '请重新登录',
    '管理员账号不存在或已停用',
    '员工账号不存在或已停用'
  ].some(text => message.includes(text))
}

function redirectToLogin() {
  if (redirectingToLogin || window.location.hash.startsWith('#/login')) return
  redirectingToLogin = true
  const currentRoute = window.location.hash.replace(/^#/, '') || '/'
  store.commit('logout')
  window.location.replace(`#/login?reason=expired&redirect=${encodeURIComponent(currentRoute)}`)
}

function isProxyConnectionError(error) {
  const responseData = error.response?.data
  return error.response?.status === 500 &&
    typeof responseData === 'string' &&
    responseData.includes('Proxy error')
}

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 90000
})

http.interceptors.request.use(config => {
  const token = localStorage.getItem('BLOG_AI_TOKEN')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  response => {
    const body = response.data
    if (body && body.success === false) {
      if (isLoginExpired(response.status, body)) {
        redirectToLogin()
        return Promise.reject(new Error(body.message || '登录已过期'))
      }
      const message = userFacingMessage(body.message) || '请求失败'
      if (!response.config?.silent) Message.error(message)
      return Promise.reject(new Error(message))
    }
    return body && Object.prototype.hasOwnProperty.call(body, 'data') ? body.data : body
  },
  error => {
    if (axios.isCancel(error) || error.code === 'ERR_CANCELED') return Promise.reject(error)
    const responseData = error.response?.data
    if (isLoginExpired(error.response?.status, responseData)) {
      redirectToLogin()
      return Promise.reject(error)
    }
    const networkMessage = error.message === 'Network Error'
      ? '网络请求中断：请确认当前环境的后端服务可访问，或稍后刷新页面重试。'
      : ''
    const message = userFacingMessage(networkMessage || (typeof responseData === 'string'
      ? responseData
      : responseData?.message || error.message || '网络异常'))
    if (!isProxyConnectionError(error) && !error.config?.silent) {
      Message.error(message)
    }
    return Promise.reject(error)
  }
)

export default http
